import lightTombstone from './../../images/light-tombstone.png';
import darkTombstone from './../../images/dark-tombstone.png';

export default function NotFoundGhosts() {
  return (
    <>
      {/* middle tombstone */}
      <img
        src={lightTombstone}
        alt="Friendly tombstone"
        className="fixed bottom-[1em] w-48 z-0 block dark:hidden"
      />
      <img
        src={darkTombstone}
        alt="Friendly tombstone"
        className="fixed bottom-[1em] w-48 z-0 hidden dark:block"
      />
    </>
  );
}
